import React, { createContext, useContext, useState, useMemo, useCallback, ReactNode } from 'react';

/** Visibility state of the OSAT modal. Data (eligibility / submit / dismiss) lives in hooks. */
export interface OsatModalContextType {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

const OsatModalContext = createContext<OsatModalContextType | undefined>(undefined);

export const OsatModalProvider = ({ children }: { children: ReactNode }) => {
  const [isOpen, setIsOpen] = useState(false);

  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);

  const value = useMemo<OsatModalContextType>(
    () => ({ isOpen, open, close }),
    [isOpen, open, close],
  );

  return <OsatModalContext.Provider value={value}>{children}</OsatModalContext.Provider>;
};

export const useOsatModal = () => {
  const context = useContext(OsatModalContext);
  if (!context) throw new Error('useOsatModal must be used within OsatModalProvider');
  return context;
};
